import { Attachment } from "../../../domain/model/Attachment";
import { Message } from "../../../domain/model/Auth";
import {
  DiscountCode,
  DiscountCodeCheckRedeemableRequestModel,
  DiscountCodeCheckRedeemableResponseModel,
} from "../../../domain/model/DiscountCode";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { DiscountCodeRepository } from "./DiscountCodeRepository";

export class DiscountCodeRepositoryImpl implements DiscountCodeRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  checkIfRedeemable(
    model: DiscountCodeCheckRedeemableRequestModel
  ): Promise<Response<DiscountCodeCheckRedeemableResponseModel>> {
    return this.apiService.checkIfRedeemable(model);
  }
  redeem(
    discountCodeId: string,
    numberOfGamesPurchased?: number
  ): Promise<Response<Message>> {
    return this.apiService.redeem(discountCodeId, numberOfGamesPurchased);
  }
}
